import { render, staticRenderFns } from "./ReportResultTable.vue?vue&type=template&id=873288a0"
import script from "./ReportResultTable.vue?vue&type=script&lang=js"
export * from "./ReportResultTable.vue?vue&type=script&lang=js"
import style0 from "./ReportResultTable.vue?vue&type=style&index=0&id=873288a0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports